import { TextMarkerTextSection } from 'components/minute/sidebar/MarkerSidebar/TextMarkerSidebar/TextMarkerTextSection';
import { MarkerControlsSection } from 'components/minute/sidebar/MarkerSidebar/shared/MarkerControlsSection';
import { MarkerFloorSection } from 'components/minute/sidebar/MarkerSidebar/shared/MarkerFloorSection';
import { ITextV2WorldMarker } from 'react-give-me-map';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    marker: ITextV2WorldMarker;
}

export const TextMarkerSidebar = (props: Props): JSX.Element => {
    return (
        <S_TextMarkerSidebar className={props.className}>
            <TextMarkerTextSection marker={props.marker} />
            <MarkerFloorSection marker={props.marker} />
            <MarkerControlsSection marker={props.marker} />
        </S_TextMarkerSidebar>
    );
};

const S_TextMarkerSidebar = styled.div``;
